import { Auth, Commons, Options, UserAnimator, UserOperator } from 'constants/storage.types';
import { isBrowser } from 'utils/helper';
import { ENUM_STORAGE_ACCESS_TOKEN, ENUM_STORAGE_ANIMATOR_TAB, ENUM_STORAGE_PATH, ENUM_STORAGE_REFRESH_TOKEN } from 'utils/hooks/storage/storageActions';
import Cookies from 'js-cookie';

export const setStoragePath = (path: string) => {
	if(isBrowser) {
		sessionStorage.setItem(ENUM_STORAGE_PATH, path);
	}
};

export const resetStoragePath = () => {
	if(isBrowser) {
		sessionStorage.removeItem(ENUM_STORAGE_PATH);
	}
};

export const setWindowUser = (data: UserOperator | UserAnimator) => {
	if(isBrowser) {
		window.user = data;
	}
};

export const setWindowCommons = (data: Commons) => {
	if(isBrowser) {
		window.commons = data;
	}
};

export const setWindowOptions = (data: Options) => {
	if(isBrowser) {
		window.options = data;
	}
};

export const setUserAuth = (response: { data: Auth }) => {
	if(isBrowser) {
		if(response.data.scope.includes('animator')) {
			window.accessToken = response.data.accessToken;
			window.refreshToken = response.data.refreshToken;
			sessionStorage.setItem(ENUM_STORAGE_ANIMATOR_TAB, 'true');
		}
		if(response.data.scope.includes('operator')) {
			sessionStorage.removeItem(ENUM_STORAGE_ANIMATOR_TAB);
			Cookies.set(ENUM_STORAGE_ACCESS_TOKEN, response.data.accessToken, { sameSite: 'strict', secure: true });
			Cookies.set(ENUM_STORAGE_REFRESH_TOKEN, response.data.refreshToken, { sameSite: 'strict', secure: true })
		}
	}
};

export const resetAnimatorAuth = () => {
	if(isBrowser) {
		delete window.accessToken;
		delete window.refreshToken;
	}
};

export const resetOperatorAuth = () => {
	if(isBrowser) {
		Cookies.remove(ENUM_STORAGE_ACCESS_TOKEN);
		Cookies.remove(ENUM_STORAGE_REFRESH_TOKEN)
	}
};

export const resetWindow = () => {
	if(isBrowser) {
		delete window.user;
		delete window.commons;
		delete window.options;
		localStorage.removeItem('user');
		localStorage.removeItem('commons');
		localStorage.removeItem('options');
	}
};
